<template>
  <div class="web-status-filter" role="group" aria-label="Web status">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="web-status-filter-button"
      :class="[
        `web-status-filter-button--${option.value}`,
        { 'is-selected': value === option.value },
      ]"
      :aria-pressed="String(value === option.value)"
      @click="select(option.value)"
    >
      <span class="web-status-filter-dot" aria-hidden="true"></span>
      {{ option.text }}
    </button>
  </div>
</template>

<script>
export default {
  name: "CatalogWebStatusFilter",
  props: {
    value: {
      type: String,
      default: "all",
    },
  },
  data() {
    return {
      options: [
        { text: "All", value: "all" },
        { text: "Active", value: "active" },
        { text: "Inactive", value: "inactive" },
      ],
    };
  },
  methods: {
    select(nextValue) {
      this.$emit("change", nextValue);
      this.$emit("input", nextValue);
    },
  },
};
</script>

<style scoped>
.web-status-filter {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

.web-status-filter-button {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  height: 36px;
  padding: 0 0.7rem;
  border: 0;
  border-radius: 4px;
  color: #707070;
  background: transparent;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
}

.web-status-filter-dot {
  width: 0.55rem;
  height: 0.55rem;
  flex: 0 0 auto;
  border-radius: 50%;
}

.web-status-filter-button--all .web-status-filter-dot {
  background: #8a8a8a;
}

.web-status-filter-button--active .web-status-filter-dot {
  background: #1f6b3a;
}

.web-status-filter-button--inactive .web-status-filter-dot {
  background: #c45c12;
}

.web-status-filter-button.is-selected {
  color: #252525;
  font-weight: 600;
}

.web-status-filter-button:hover,
.web-status-filter-button:focus {
  background: transparent;
  color: #252525;
}

.web-status-filter-button:focus:not(:focus-visible) {
  outline: none;
}

.web-status-filter-button:focus-visible {
  outline: 2px solid #35647b;
  outline-offset: 2px;
}
</style>
